import { PlannedService } from "app/models/plannedService";

export class PlannedServicesDoneFilterOptions {

  public deadlineRange: Date[];
  public location: string;
  public name: string;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/dto/plannedServicesDoneFilterOptions.ts